import React from 'react';
import LearningLayout from '../Components/LearningPlatform/LearningLayout';
import FlashcardsSection from '../Components/LearningPlatform/FlashcardsSection';

function FlashcardsPage() {
    return (
        <LearningLayout>
            <div className='flex-1 overflow-auto flex flex-col'>
                {/* Header with Title */}
                <div className='sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-md'>
                    <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-6'>
                        <h1 className='text-3xl font-bold text-gray-800'>Flashcards</h1>
                    </div>
                </div>

                {/* Content */}
                <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-8'>
                    <div className='max-w-6xl mx-auto'>
                        <FlashcardsSection />
                    </div>
                </div>
            </div>
        </LearningLayout>
    );
}

export default FlashcardsPage;
